import { render, staticRenderFns } from "./editConnect.vue?vue&type=template&id=39686012&scoped=true"
import script from "./editConnect.vue?vue&type=script&lang=js"
export * from "./editConnect.vue?vue&type=script&lang=js"
import style0 from "./editConnect.vue?vue&type=style&index=0&id=39686012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39686012",
  null
  
)

export default component.exports